__turbopack_context__.v({
  "counter": "AnimatedCounter-module__4tK3cq__counter",
  "label": "AnimatedCounter-module__4tK3cq__label",
  "value": "AnimatedCounter-module__4tK3cq__value",
});
